import { Machine } from '../machine/machine';
import { User } from '../user/user';

export class Client {
    id: number;
    name: string;
    address: string;
    email: string;
    users: User[];
    machines: Machine[];
    locations: Location[];
    contact_name: string;
    phone_number: string;
}

export class ClientCreate {
    id: number;
    name: string;
    address: string;
    email: string;
    locations: number[];
    contact_name: string;
    phone_number: string;
}